import '../../resources/css/common/ModalLoading.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
// import { MoonLoader} from 'react-spinners';
import Loading from '../../components/common/Loading';

// const override = `
//     display: block;
//     margin: 0 auto;
//     border-color: red;
// `;

class ModalLoading extends Component {
  // constructor(props) {
  //   super(props);

  //   this.updateLoading = this.updateLoading.bind(this);

  //   this.state = {
  //     loading: false
  //   }
  // }

  // updateLoading() {
  //   let loading = (this.props.loading) ? this.props.loading : false;
  //   this.setState({
  //     loading: loading
  //   });
  // }

  // componentDidMount() {
  //   // if call render will do this method
  //   this.updateLoading();
  // }
  
  // componentDidUpdate (prevProps, prevState, snapshot) {
  //   // if props change will call this method
  //   if (prevProps.loading !== this.props.loading) {
  //     this.updateLoading();
  //   }    
  // }

  renderText = () => {
    const { loadingText } = this.props;
    if (loadingText.includes('<br/>')) {
      let renderLoadingText = [];
      loadingText.split('<br/>').forEach((element, index) => {
        renderLoadingText.push(<div style={{padding: '1% 0%'}} key={'loading-text_'+index}>{element}</div>)
      });
      return renderLoadingText;
    }
    else {
      return <label>{loadingText}</label>;
    }
  }

  render() {
    const { isLoadingShow, loadingTitle } = this.props;

    let renderContent;
    if (isLoadingShow) {
      renderContent = (
        <Modal
            show={isLoadingShow}
            dialogClassName='modal-loading'
            centered
        >
          <Modal.Body>
            <div className='area-modal-loading-header'>
                <label>{loadingTitle}</label>
            </div>
            <div className='area-modal-loading-content'>
              <Loading loading={true}></Loading>
              {/* <MoonLoader
                  css={override}
                  sizeUnit={"px"}
                  size={48}
                  color={'#123abc'}
                  loading={true}
              /> */}
              <br />
              {this.renderText()}
            </div>
          </Modal.Body>
        </Modal>
      )
    } else {
      renderContent = (<div className='modal-detail-empty'></div>);
    }

    return (
      <div className='area-modal-loading'>
          {renderContent}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isLoadingShow: state.commonReducers.isLoadingShow,
    loadingText: state.commonReducers.loadingText,
    loadingTitle: state.commonReducers.loadingTitle
  }
}

export default connect(
  mapStateToProps,
  { }
)(ModalLoading)